import React from 'react'
import PropTypes from 'prop-types'
import { ModalContainer } from './component.styles'
import CloseButton from 'components/CloseButton'
import AppConfirmationDialog from '../AppConfirmationDialog/index'

const StutterStepModal = ({ header, isOpen, onCancel, onConfirm, text }) => {
  return (
    <ModalContainer dataTestId="confirmation-modal" isModalOpen={isOpen}>
      <CloseButton
        dataTestId="confirmation-modal-close-button"
        onClick={onCancel}
      />
      <AppConfirmationDialog
        confirmText="CONFIRM"
        header={header}
        onCancel={onCancel}
        onConfirm={onConfirm}
        showIcon={false}
        text={text}
      />
    </ModalContainer>
  )
}

StutterStepModal.propTypes = {
  header: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  text: PropTypes.string,
}

export default StutterStepModal
